import { Chip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { reportNameMessages } from '../modules/audit/modules/reports/constants';

interface ReportTypeChipProps {
  reportType: string;
  size?: 'small' | 'medium';
}

/**
 * Renders a chip with the report type label using centralized report name messages.
 * Falls back to the raw reportType when no message is defined in constants.
 */
export function ReportTypeChip({ reportType, size = 'medium' }: ReportTypeChipProps) {
  const message = reportNameMessages[reportType];

  return (
    <Chip
      label={message ? <FormattedMessage {...message} /> : reportType}
      color="info"
      size={size}
    />
  );
}
